import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["to", "title", "linkAs", "contentProps", "internal"];
import React from 'react';
import LinkContent from './components/LinkContent';
import { ObjectPropsPropType } from '../../services/proptypes';
import InternalLink from '../InternalLink';
import OutboundLink from '../OutboundLink';
var defaultProps = {
  internal: true,
  linkAs: 'span',
  contentProps: {}
};
export default function Link(_ref) {
  var to = _ref.to,
    title = _ref.title,
    linkAs = _ref.linkAs,
    contentProps = _ref.contentProps,
    internal = _ref.internal,
    rest = _objectWithoutProperties(_ref, _excluded);
  function renderExternalLink() {
    return /*#__PURE__*/React.createElement(OutboundLink, _extends({
      label: title,
      to: to
    }, rest), /*#__PURE__*/React.createElement(LinkContent, _extends({
      linkAs: linkAs,
      title: title
    }, contentProps)));
  }
  function renderInternalLink() {
    return /*#__PURE__*/React.createElement(InternalLink, _extends({
      to: to,
      label: title
    }, rest), /*#__PURE__*/React.createElement(LinkContent, _extends({
      linkAs: linkAs,
      title: title
    }, contentProps)));
  }
  return internal ? renderInternalLink() : renderExternalLink();
}
Link.defaultProps = defaultProps;